import ShopDTO from "@/dto/shop/ShopDTO";
import ShopType from "@/enum/ShopType";
import { DisabledPendingShipmentRefundingShipShopTypes, SupplierShopTypes } from "@/utils/ShopUtils";
import { Alert, Button } from "antd";
import React from "react";
import OrderTab from "../../enum/OrderTab";
import NewShopAlert from "../NewShopAlert";
import { useOrderManagementStore } from "@/scenes/OrderManagementForAllShop/stores/OrderManagementForAllShopStore";
import { observer } from "mobx-react-lite";
import { useModalStore } from "@/hooks/Modal/hooks";
import NewVirtualPhoneModal from "./NewVirtualPhoneModal";
import ShopTypeNameMap from "@/map/ShopTypeNameMap";

interface PlatformNotificationProps {
    shop: ShopDTO;
    tab: OrderTab;
}

const PlatformNotification: React.FC<PlatformNotificationProps> = function (props) {
    const { shop, tab } = props;

    const modalStore = useModalStore();

    function buildAliC2MNotification() {
        if (shop.type === ShopType.ALI_C2M) {
            return (
                <>
                    <Alert
                        type="warning"
                        className="mb10"
                        closable
                        title={
                            <div>
                                <p>
                                    <span>【公告】</span>
                                    <span>
                                        1
                                        由于淘工厂接口限制：订单同步最少会有半小时的延迟，如订单A是12:00付款，最快也需12:30时淘工厂的接口
                                        才可以同步到发货易
                                    </span>
                                </p>

                                <p style={{ marginLeft: "55px" }}>2 由于淘工厂接口限制：软件内的备注不会同步到后台</p>
                            </div>
                        }
                    />
                </>
            );
        }
    }

    function buildPddFdsNotification() {
        if (shop.type === ShopType.PDD_FDS) {
            return (
                <Alert
                    type="warning"
                    className="mb10"
                    closable
                    title={
                        <div className="flex">
                            <div className="mr10">注意:</div>
                            <div>
                                1，拼多多代发订单接口不返回收货人姓名，手机号，街道详细地址，但不影响订单打印电子面单
                                <br />
                                2，打印电子面单必须使用本店铺开通的电子面单进行打印
                            </div>
                        </div>
                    }
                />
            );
        }
    }

    function buildDouDianSupplierNotification() {
        if (shop.type === ShopType.DOUDIAN_SUPPLIER) {
            return (
                <>
                    <Alert
                        type="warning"
                        className="mb10"
                        closable
                        title={
                            <div className="flex">
                                <div className="mr10">注意:</div>
                                <div>
                                    抖店供应链订单接口不返回收货人姓名，手机号，街道详细地址，但不影响订单打印电子面单
                                </div>
                            </div>
                        }
                    />
                </>
            );
        }
    }

    function buildTbNotification() {
        if (shop.type === ShopType.TAOBAO) {
            return <></>;
        }
    }

    function buildJdNotification() {
        if (shop.type === ShopType.JD) {
            return <></>;
        }
    }

    function buildSupplierShopNotification() {
        if (SupplierShopTypes.includes(shop.type)) {
            return (
                <Alert
                    title={
                        <span>
                            【通知】供货商系统只为您的账户保留最近90天的订单数据，已出账的账单有效期保留30天，请需要对账的客户及时处理订单账目
                        </span>
                    }
                    type="error"
                    className="mb10"
                />
            );
        }
    }

    function buildAIKUCUNNotification() {
        if (ShopType.AIKUCUN === shop.type) {
            return <></>;
        }
    }

    function buildIndependentAndManualNotification() {
        if ([ShopType.MANUAL, ShopType.INDEPENDENT_MANUAL].includes(shop.type)) {
            return (
                <>
                    {tab === OrderTab.PENDING_SHIPMENT ? (
                        <Alert
                            title={
                                <span>
                                    【温馨提示】为更合理管理您的手工订单数据，如果订单已打印且包裹寄出后请点击下方的“设为已发货”按钮将订单设置为“已发货”状态避免不同状态订单混淆，
                                    <a
                                        href="https://qw15p3s8hv.feishu.cn/wiki/X33EwmBDOiAJBNk466LcXhSAn5f"
                                        target="_blank"
                                    >
                                        点击这里查看具体操作
                                    </a>
                                </span>
                            }
                            type="warning"
                            className="mb10"
                        ></Alert>
                    ) : null}

                    {tab === OrderTab.SHIPPED ? (
                        <Alert
                            title={
                                <span>
                                    【温馨提示】手工订单设置为“已发货”状态7天后会自动变为“已成功”状态，如果“已发货”下搜索不到对应订单可到“已成功”下尝试搜索
                                </span>
                            }
                            type="warning"
                            className="mb10"
                        ></Alert>
                    ) : null}
                </>
            );
        }
    }

    function buildAliNotification() {
        if (shop.type === ShopType.ALIBABA) {
            return <></>;
        }
    }

    function buildKwaiNotification() {
        if (shop.type === ShopType.KWAI) {
            return <></>;
        }
    }

    function buildDouDianNotification() {
        if (shop.type === ShopType.DOUDIAN) {
            return <></>;
        }
    }

    function buildChannelShopNotification() {
        if (shop.type === ShopType.CHANNEL_SHOP) {
            return <></>;
        }
    }

    function buildPDDNotification() {
        if (shop.type === ShopType.PINDUODUO) {
            return <></>;
        }
    }

    function buildDouDianIOPNotification() {
        if (shop.type === ShopType.DOUDIAN_IOP) {
            return <></>;
        }
    }

    function buildWeiDianNotification() {
        if (shop.type !== ShopType.WEIDIAN) return null;

        return <></>;
    }

    function buildXhsNotification() {
        if (shop.type !== ShopType.XIAOHONGSHU) return null;

        return (
            <>
                <Alert
                    type="warning"
                    className="mb10"
                    closable
                    title={
                        <div>
                            【通知】为进一步加强消费者个人信息保护，小红书平台于2025年7月26日开始推行虚拟号。 
                            <a
                                target="_blank"
                                className="ml5"
                                href="https://school.xiaohongshu.com/lesson/normal/da0cc9f5056042438f605a73517fdf04"
                            >
                                详情查看官方通知
                            </a>
                        </div>
                    }
                />
            </>
        );
    }

    function buildEncryptAddressNotification() {
        if (
            ![
                ShopType.MANUAL,
                ShopType.INDEPENDENT_MANUAL,
                ShopType.FKW,
                ShopType.WSC,
                ShopType.FKMDT,
                ShopType.HKMDXT,
                ShopType.YMDY,
                ShopType.HCTY,
                ShopType.DOUBB,
                ShopType.MOGUJIE,
                ShopType.DUXIAODIAN,
                ShopType.WEIMOB_EC,
                ShopType.WEBUY,
                ShopType.KTT,
            ].includes(shop.type)
        )
            return null;

        return (
            <Alert
                type="error"
                className="mb10"
                title={
                    <span>
                        <span className="error">
                            【重要通知】关于{ShopTypeNameMap[shop?.type]}订单隐私保护功能调整的公告
                        </span>
                        <Button
                            type="link"
                            size="small"
                            className="ml5"
                            onClick={() => {
                                modalStore.openModal(NewVirtualPhoneModal, {
                                    shopType: shop.type,
                                });
                            }}
                        >
                            点击查看
                        </Button>
                    </span>
                }
            />
        );
    }

    return (
        <>
            <NewShopAlert shop={shop} />

            {buildEncryptAddressNotification()}

            {buildAliC2MNotification()}
            {buildPDDNotification()}
            {buildPddFdsNotification()}
            {buildDouDianNotification()}
            {buildDouDianSupplierNotification()}
            {buildDouDianIOPNotification()}
            {buildTbNotification()}
            {buildJdNotification()}
            {buildSupplierShopNotification()}
            {buildAIKUCUNNotification()}
            {buildChannelShopNotification()}
            {buildIndependentAndManualNotification()}
            {buildXhsNotification()}
            {DisabledPendingShipmentRefundingShipShopTypes.includes(shop.type) &&
            tab === OrderTab.PENDING_SHIPMENT_REFUNDING ? (
                <Alert
                    title={
                        <span>
                            请注意：退款中的抖店订单请先前往抖店后台处理售后，再回来进行发货。如急需发货建议前往后台发货
                        </span>
                    }
                    type="warning"
                    className="mb10"
                ></Alert>
            ) : null}

            {buildAliNotification()}
            {buildKwaiNotification()}
            {buildWeiDianNotification()}
        </>
    );
};

export default observer(PlatformNotification);
